import { Card, CardContent } from "@/components/ui/card";
import { Lock } from "lucide-react";

export function ModuleLockedPanel() {
  return (
    <Card className="border-dashed">
      <CardContent className="py-16 text-center">
        <div className="flex flex-col items-center gap-4">
          <div className="p-4 rounded-full bg-muted">
            <Lock className="h-8 w-8 text-muted-foreground" />
          </div>
          <div className="space-y-2">
            <h3 className="text-lg font-semibold text-foreground">Module Locked</h3>
            <p className="text-sm text-muted-foreground max-w-md mx-auto">
              This module hasn't been unlocked yet. Your instructor will unlock it when your cohort is ready to proceed.
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
